import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "hidden", "submit"]

  connect() {
    this.sync()
  }

  input(event) {
    const input = event.target
    input.value = (input.value || "").replace(/\D/g, "").slice(0, 1)

    if (input.value.length === 1) {
      this.focusNext(input)
    }

    this.sync()
  }

  keydown(event) {
    const input = event.target

    if (event.key === "Backspace" && !input.value) {
      this.focusPrevious(input)
      return
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.focusPrevious(input)
    }

    if (event.key === "ArrowRight") {
      event.preventDefault()
      this.focusNext(input)
    }
  }

  paste(event) {
    event.preventDefault()

    const pasted = (event.clipboardData || window.clipboardData).getData("text") || ""
    const digits = pasted.replace(/\D/g, "").slice(0, this.digitTargets.length).split("")

    if (digits.length === 0) return

    this.digitTargets.forEach((target, index) => {
      target.value = digits[index] || ""
    })

    const focusTarget = this.digitTargets[Math.min(digits.length, this.digitTargets.length) - 1]
    if (focusTarget) focusTarget.focus()

    this.sync()
  }

  sync() {
    const code = this.digitTargets.map((target) => target.value).join("")
    this.hiddenTarget.value = code

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = code.length !== this.digitTargets.length
    }
  }

  focusNext(input) {
    const index = this.digitTargets.indexOf(input)
    const next = this.digitTargets[index + 1]
    if (next) next.focus()
  }

  focusPrevious(input) {
    const index = this.digitTargets.indexOf(input)
    const previous = this.digitTargets[index - 1]
    if (previous) previous.focus()
  }
}
